export function validURL(field) {
    // Add protocol if missing
    if (
        field.value.indexOf("http://") !== 0 &&
        field.value.indexOf("https://") !== 0
    ) {
        field.value = "http://" + field.value;
    }

    // Use browser's built-in URL constructor for validation
    // This is much safer and more reliable than complex regex
    try {
        const url = new URL(field.value);
        // Ensure it's http or https protocol
        return url.protocol === "http:" || url.protocol === "https:";
    } catch (error) {
        // Invalid URL format
        return false;
    }
}
